export const DEFAULT_TICKET_LIST_SORT_BY = 'lastCommunicationAt desc';
